function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAward = function SvgAward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 61",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "award",
    transform: "matrix(1.61997,0,0,1.61997,-115.008,125.073)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0723394,0,0,0.0723394,70.994,9.49239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.963,380.484L148.61,380.484L148.61,400.691L368.714,400.691L368.714,380.484L334.362,380.484L182.963,380.484Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.399,314.246L182.963,314.246C180.252,314.246 178.046,316.459 178.046,319.178L178.046,367.553C178.046,370.272 180.252,372.485 182.963,372.485L334.362,372.485C337.073,372.485 339.279,370.272 339.279,367.553L339.279,319.178C339.279,316.459 337.073,314.246 334.362,314.246L300.455,314.246L214.399,314.246Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.592,51.473L77.537,52.477C78.199,81.071 86.76,138.032 143.505,144.907C129.675,115.829 120.879,83.757 117.571,50.643L117.592,51.473Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,52.578C222.629,52.578 195.48,79.74 195.48,113.127C195.48,146.498 222.629,173.647 256,173.647C289.387,173.647 316.55,146.499 316.55,113.127C316.55,79.74 289.387,52.578 256,52.578ZM279.926,149.346C279.803,150.116 279.635,150.758 279.405,151.219C279.206,151.711 278.928,152.018 278.653,152.201C278.376,152.416 278.039,152.539 277.701,152.539L234.392,152.539C234.085,152.539 233.778,152.416 233.471,152.201C233.225,152.017 232.965,151.711 232.735,151.219C232.52,150.758 232.351,150.115 232.213,149.346C232.09,148.549 232.029,147.598 232.029,146.461C232.029,145.326 232.091,144.344 232.183,143.545C232.29,142.746 232.458,142.133 232.673,141.643C232.903,141.182 233.149,140.815 233.44,140.598C233.717,140.354 234.055,140.262 234.392,140.262L249.002,140.262L249.002,89.34L236.448,96.278C235.527,96.708 234.76,97.014 234.177,97.106C233.594,97.198 233.134,97.075 232.78,96.739C232.458,96.368 232.212,95.817 232.09,94.958C231.967,94.097 231.906,92.901 231.906,91.366C231.906,90.415 231.937,89.616 231.968,88.971C232.029,88.358 232.121,87.836 232.29,87.407C232.428,86.946 232.658,86.577 232.95,86.302C233.226,86.025 233.61,85.718 234.086,85.382L250.891,74.515C251.091,74.361 251.336,74.208 251.643,74.117C251.95,74.025 252.334,73.931 252.839,73.871C253.299,73.81 253.944,73.779 254.742,73.75C255.509,73.719 256.522,73.719 257.78,73.719C259.316,73.719 260.544,73.75 261.495,73.811C262.446,73.872 263.183,73.963 263.643,74.118C264.134,74.27 264.456,74.456 264.625,74.702C264.778,74.946 264.87,75.222 264.87,75.622L264.87,140.265L277.67,140.265C278.038,140.265 278.375,140.357 278.684,140.601C278.991,140.818 279.237,141.185 279.466,141.646C279.696,142.136 279.864,142.75 279.973,143.548C280.064,144.347 280.095,145.329 280.095,146.464C280.095,147.598 280.049,148.549 279.926,149.346Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.994,408.691C96.819,408.691 93.423,412.074 93.423,416.232L93.423,478.97C93.423,483.128 96.819,486.513 100.994,486.513L416.347,486.513C420.513,486.513 423.903,483.128 423.903,478.97L423.903,416.232C423.903,412.074 420.513,408.691 416.347,408.691L368.924,408.691L148.417,408.691L100.994,408.691Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.112,24.83C125.408,123.799 174.644,194.865 220.761,228.594L222.4,229.791L222.4,306.246L292.456,306.246L292.456,229.791L294.095,228.594C340.226,194.856 389.478,123.783 390.774,24.83L124.112,24.83ZM256,181.646C218.218,181.646 187.48,150.91 187.48,113.126C187.48,75.327 218.218,44.577 256,44.577C293.799,44.577 324.55,75.327 324.55,113.126C324.55,150.91 293.799,181.646 256,181.646Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.565,144.479C425.552,135.95 433.812,80.545 434.462,52.477L397.216,51.543C393.854,84.172 385.16,115.777 371.565,144.479Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/award.723a20b4.svg";
export { ForwardRef as ReactComponent };